import { gql, TypedDocumentNode } from "@apollo/client";

export type BackgroundCheckDispositionStatus =
  | "APPROVED"
  | "DENIED"
  | "DOCUMENTATION_NEEDED"
  | "IN_REVIEW"
  | "IN_PROGRESS";

export type UpsertPersonBackgroundCheckResponse = {
  upsertPersonBackgroundCheck: {
    success: boolean;
    message: string | null;
    backgroundCheck: {
      status: string | null;
      screenedAt: string | null;
      expiredAt: string | null;
    } | null;
  };
};

export type UpsertPersonBackgroundCheckVariables = {
  input: {
    pgaId: string;
    status: BackgroundCheckDispositionStatus;
    screenedOn: string;
    note?: string;
  };
};

export const UPSERT_PERSON_BACKGROUND_CHECK_MUTATION: TypedDocumentNode<
  UpsertPersonBackgroundCheckResponse,
  UpsertPersonBackgroundCheckVariables
> = gql`
  mutation UpsertPersonBackgroundCheck($input: BackofficeUpsertPersonBackgroundCheckInput!) {
    upsertPersonBackgroundCheck(input: $input) {
      success
      message
      backgroundCheck {
        status
        screenedAt
        expiredAt
      }
    }
  }
`;
